import { FC } from 'react'
import { MiFooter } from '../../components/mi/Footer'
import { MiNavbar } from '../../components/mi/Navbar'
import { ResendEmailSection } from '../../components/mi/account/resendEmail'
import { StyleBody } from '../../styles/mi'

export const ResendEmail: FC = () => {
  return (
    <StyleBody>
      <MiNavbar />
      <ResendEmailSection></ResendEmailSection>
      <MiFooter />
    </StyleBody>
  )
}
